<template>
  <div class="app-root">
    <div class="app-main">
      <router-view v-if="show"></router-view>
    </div>
  </div>
</template>
<script>
// import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
// import 'remixicon/fonts/remixicon.css'

import { setDbScope, migrateLegacyDbs } from '@/services/scopedDB'
import axios from 'axios'
import storeSnapshot from '@/services/storeSnapshot'

export default {
  name: 'App',
  data(){
    return {
      show:false,
    }
  },
  created() {
    this.show=false;
    // 로그인 상태 확인은 store에서 1회만 수행 (라우터 가드와 공유)
    this.$store.dispatch('ensureAuth')
    .then( async loggedIn => {
      if (loggedIn) {
        console.log("user confirmed");
        // 브라우저에 쌓이는 데이터(키워드 수집·분석 등)를 계정별 서랍으로 가른다.
        // 화면이 뜨기 전에 끝내야 한다 — 화면이 먼저 열면 옛 이름으로 써버린다
        const uid = this.$store.state.user && this.$store.state.user._id;
        setDbScope(uid);
        await migrateLegacyDbs(uid);

        // 계정을 떠날 때 보관해 둔 store 가 있으면 꺼내 얹는다.
        // 화면들이 "store 에 없으면 서버에서 받는다"로 되어 있어, 채워두면 다시 받지 않는다.
        // 그 사이 데이터가 바뀌었으면(stamp 불일치) 보관함이 알아서 null 을 주고,
        // 그때는 평소대로 서버에서 받는다
        try {
          const snap = await storeSnapshot.loadSnapshot(uid, await this.fetchDataStamp());
          if (snap) {
            this.$store.commit('restoreSnapshot', snap);
            console.log('[storeSnapshot] 복원', Object.keys(snap).join(', '));
          }
        } catch (e) {
          console.error('보관해 둔 데이터 복원 실패 — 서버에서 받습니다', e);
        }
      } else if (window.location.pathname.startsWith('/pages/import-photo')) {
        // 입고 핸드폰 촬영 페이지 — 로그인 없이 QR 토큰으로 연다(서버가 토큰을 검증한다). import-photo-box·-session 도 포함 — 빠져 있어 QR 을 찍으면 로그인 화면이 떴다(2026-10-20 杨英文)
      } else {
        // 이전에 로그인한 적이 있으면 세션 만료 안내, 아니면 조용히 이동
        const wasLoggedIn = localStorage.getItem('wasLoggedIn');
        if (wasLoggedIn === 'true') {
          localStorage.removeItem('wasLoggedIn');
          // 세션 만료 메시지를 query로 전달하여 로그인 페이지에서 표시
          this.$router.push({name: 'auth.login', query: { expired: 'true' }}).catch(()=>{});
        } else {
          this.$router.push({name: 'auth.login'}).catch(()=>{});
        }
      }
      this.show=true;
    }).catch((e)=>{
      console.error(e);
      // 네트워크 오류 시에도 로그인 페이지로 이동
      this.$router.push({name: 'auth.login'}).catch(()=>{});
      this.show=true;
    })
  },
  mounted() {
    // 서비스 모듈(예: seoService)이 alert 대신 보내는 비차단 안내 — alert 는 화면 JS 전체를 세워
    // 에이전트가 시킨 작업(데몬 명령)까지 멈춘다. 여기서 토스트로만 띄운다
    window.addEventListener('couplus:notice', this.onNotice);
  },
  beforeDestroy() {
    window.removeEventListener('couplus:notice', this.onNotice);
  },
  methods: {
    onNotice(e) {
      const d = (e && e.detail) || {};
      if (!d.message) return;
      this.$bvToast.toast(String(d.message), { title: d.title || '알림', variant: d.variant || 'danger', solid: true, autoHideDelay: 20000, toaster: 'b-toaster-top-right' });
    },
    // 보관해 둔 store 가 아직 쓸 만한지 판단할 기준(이 회사 데이터가 바뀐 시각).
    // 확인할 수 없으면 null → 보관함을 쓰지 않고 서버에서 받는다
    async fetchDataStamp() {
      try {
        const res = await axios.post('/api/growth/getLedgerStamp', {});
        if (res.data?.res !== 'success') return null;
        return res.data.stamp || '';
      } catch (e) {
        console.error('데이터 변경시각 확인 실패', e);
        return null;
      }
    },
    // googleTranslateElementInit() {
    //   window.google.translate.TranslateElement(
    //     { pageLanguage: "en" },
    //     "google_translate_element"
    //   );
    // },
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/backend.scss";
  @import "./assets/css/custom.css";
</style>
